module.exports = __webpack_public_path__ + "static/media/santa_carolina.499401e7.png";